// exports ProviderType - an immutable object 'enum'
// usage: import { ProviderType } from '../../enums/ProviderType';
const providerTypes = {
    Inpatient: 101, 
    Outpatient: 102, 
    Physician: 103, 
    Specialty: 104
};
Object.freeze(providerTypes);
export const ProviderType = providerTypes;